import { render } from "./mindPractice.vue?vue&type=template&id=b052e3e8&scoped=true"
import script from "./mindPractice.vue?vue&type=script&lang=js"
export * from "./mindPractice.vue?vue&type=script&lang=js"

import "./mindPractice.vue?vue&type=style&index=0&id=b052e3e8&scoped=true&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b052e3e8"]])

export default __exports__